import React from 'react';
import Layout from './Layout';
import styles from './PageLayout.module.scss';

const PageLayout = ({ children, ...rest }) => (
  <Layout {...rest}>
        <div className={styles.notice}>Due to COVID-19, we regret to announce that Marxism 2020 will be postponed until later this year. <a href='/'>Read more »</a></div>

      <div className={styles.mainContent}>
          { children }
      </div>
  </Layout>
);

export default PageLayout;